<div class="image">
</div>
<div class="info">
  <p class="info-row">
    <span class="title"></span>
  </p>

  <p class="info-row light"></p>

  <p class="info-row"></p>
</div>
